module.exports = __webpack_public_path__ + "static/media/hero-medium.e0dc8ad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/dashboard/hero-medium.jpg
// module id = 373
// module chunks = 0